import React from 'react';
import { StyledSvg, iconGenerator } from '../Icon';
const ExportIcon = ({ size, color, deg, }) => (React.createElement(StyledSvg, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", size: size, color: color, deg: deg },
    React.createElement("path", { fill: color, fillRule: "evenodd", d: "M4 3v1.556h13V3H4zm11.917 8.815L10.5 6.63l-5.417 5.185.99.916 3.762-3.617V17h1.33V9.114l3.795 3.617.957-.916z" })));
export const Export = iconGenerator(ExportIcon);
//# sourceMappingURL=Export.js.map